import React, { useState, useRef, useEffect, useContext, useCallback } from "react";
import { createPortal } from "react-dom";
import { useHistory } from "react-router-dom";
import { formatDistanceToNow } from "date-fns";
import { ptBR } from "date-fns/locale";
import openSocket from "../../services/socket-io";
import {
  playAlarmeTransferencia,
  destravarAudio,
  carregarConfigSons,
  aplicarConfigSons,
  tocarSom
} from "../../utils/soundAlerts";
import {
  pedirPermissaoNotificacao,
  mostrarNotificacaoDesktop,
  suportaNotificacao,
} from "../../utils/desktopNotification";


import {
  Popover,
  IconButton,
  List,
  ListItem,
  makeStyles,
  Badge,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Avatar,
  Tooltip,
} from "@material-ui/core";

import {
  NotificationsOutlined,
  NotificationsNoneOutlined,
  ChatBubbleOutline,
  Memory,
  ReportProblemOutlined,
  CheckCircleOutline,
  DeleteSweepOutlined,
  SwapHoriz,
  Announcement,
  PanTool,
  Close,
  DoneAll,
  OpenInNew,
  NotificationsActiveOutlined,
  SignalWifiOff,
  Wifi,
} from "@material-ui/icons";


import { AuthContext } from "../../context/Auth/AuthContext";
import { ticketEhMeu } from "../../utils/acompanha";
import api from "../../services/api";
import { toast } from "react-toastify";
import { poderDeAdmin } from "../../utils/perfil";

// Cada tipo de aviso tem cor, icone e rotulo proprios — o usuario bate o olho
// e sabe o que e sem ler.
const TIPOS = {
  message:    { rotulo: "Mensagem",          cor: "#0d9488", Icone: ChatBubbleOutline },
  transfer:   { rotulo: "Transferência",     cor: "#2563eb", Icone: SwapHoriz },
  humano:     { rotulo: "Precisa de humano", cor: "#ea580c", Icone: PanTool },
  comunicado: { rotulo: "Comunicado",        cor: "#7c3aed", Icone: Announcement },
  ai:         { rotulo: "I.A",               cor: "#0891b2", Icone: Memory },
  problem:    { rotulo: "Alerta",            cor: "#dc2626", Icone: ReportProblemOutlined },
  sale:       { rotulo: "Entrevista",            cor: "#0d9488", Icone: CheckCircleOutline },
  conexao:    { rotulo: "Conexão caiu",      cor: "#dc2626", Icone: SignalWifiOff },
  conexaoOk:  { rotulo: "Conexão voltou",    cor: "#0d9488", Icone: Wifi },
};
const tipoDe = (type) => TIPOS[type] || TIPOS.message;

const FILTROS = [
  { id: "todas", rotulo: "Todas" },
  { id: "naoLidas", rotulo: "Não lidas" },
  { id: "message", rotulo: "Mensagens" },
  { id: "transfer", rotulo: "Transferências" },
  { id: "comunicado", rotulo: "Comunicados" },
  { id: "conexao", rotulo: "Conexões" },
];

import { fundoNavy } from "../../utils/estiloNavy";

import ModalAstro from "../ModalAstro";
const useStyles = makeStyles((theme) => {
  const escuro = theme.palette.type === "dark";
  return {
    // ---------- sino
    iconButton: {
      color: theme.palette.text.primary,
      padding: 8,
      transition: "all 0.2s ease",
      "&:hover": { backgroundColor: "rgba(13,148,136,0.1)", color: "#0D9488" },
    },
    sinoTocando: { "& svg": { animation: "$balancarSino 1s ease-in-out infinite" } },
    "@keyframes balancarSino": {
      "0%, 60%, 100%": { transform: "rotate(0)" },
      "10%": { transform: "rotate(16deg)" },
      "20%": { transform: "rotate(-14deg)" },
      "30%": { transform: "rotate(8deg)" },
      "40%": { transform: "rotate(-4deg)" },
    },
    contador: {
      position: "absolute", top: -1, right: -3, minWidth: 18, height: 18, padding: "0 5px",
      borderRadius: 9, color: "#fff", fontSize: "0.68rem", fontWeight: 800, lineHeight: "18px",
      textAlign: "center", boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    },

    // ---------- quadro
    popoverPaper: {
      width: 440,
      maxWidth: "94vw",
      borderRadius: 22,
      overflow: "hidden",
      marginTop: 10,
      boxShadow: escuro
        ? "0 30px 70px rgba(0,0,0,0.6), 0 0 0 1px rgba(45,212,191,0.12)"
        : "0 30px 70px rgba(15,23,42,0.22)",
      backgroundColor: escuro ? "#0e1716" : "#f4f7fb",
      border: escuro ? "none" : "1px solid rgba(226,232,240,0.9)",
      animation: "iaModalEntrar .2s ease-out",
    },
    // mesmo azul-noite dos modais e banners
    topo: {
      position: "relative",
      overflow: "hidden",
      padding: "16px 18px 14px",
      background: fundoNavy,
      color: "#fff",
      "&::after": {
        content: '""', position: "absolute", inset: 0, pointerEvents: "none",
        backgroundImage:
          "linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)",
        backgroundSize: "22px 22px",
        maskImage: "linear-gradient(90deg, transparent 0%, #000 70%)",
        WebkitMaskImage: "linear-gradient(90deg, transparent 0%, #000 70%)",
      },
      "& > *": { position: "relative", zIndex: 1 },
    },
    topoSino: {
      width: 34, height: 34, borderRadius: 11, flexShrink: 0,
      display: "inline-flex", alignItems: "center", justifyContent: "center",
      background: "linear-gradient(135deg, #14b8a6, #0f766e)",
      boxShadow: "0 6px 16px rgba(20,184,166,0.35)",
      "& svg": { fontSize: 18, color: "#fff" },
    },
    topoLinha: { display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10 },
    topoTitulo: { fontWeight: 800, fontSize: "1.02rem", display: "flex", alignItems: "center", gap: 8 },
    topoSub: { fontSize: "0.76rem", color: "#94a3b8", marginTop: 2 },
    topoAcoes: { display: "flex", gap: 4 },
    topoBtn: {
      color: "#fff", padding: 6, borderRadius: 10, backgroundColor: "rgba(255,255,255,0.08)",
      border: "1px solid rgba(255,255,255,0.14)",
      "&:hover": { backgroundColor: "rgba(255,255,255,0.18)" },
    },
    filtros: { display: "flex", flexWrap: "wrap", gap: 6, marginTop: 12 },
    filtro: {
      border: "none", cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap",
      fontSize: "0.74rem", fontWeight: 700, padding: "5px 11px", borderRadius: 20,
      color: "#cbd5e1", backgroundColor: "rgba(255,255,255,0.07)",
      boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.12)",
      display: "inline-flex", alignItems: "center", gap: 6,
      transition: "background-color .15s, color .15s",
      "&:hover": { backgroundColor: "rgba(255,255,255,0.14)", color: "#fff" },
      "&:focus": { outline: "none" },
    },
    filtroAtivo: escuro
      ? {
          color: "#5eead4",
          background: "linear-gradient(135deg, rgba(20,184,166,.26), rgba(20,184,166,.10))",
          boxShadow: "inset 0 0 0 1px rgba(45,212,191,.45)",
          "&:hover": { color: "#5eead4" },
        }
      : { backgroundColor: "#fff", color: "#0f766e", boxShadow: "0 4px 12px rgba(0,0,0,.25)", "&:hover": { backgroundColor: "#fff", color: "#0f766e" } },
    filtroNum: { fontSize: "0.66rem", fontWeight: 800, padding: "0 6px", borderRadius: 10, backgroundColor: "rgba(0,0,0,0.12)" },

    avisoPermissao: {
      display: "flex", alignItems: "center", gap: 10, padding: "10px 16px",
      backgroundColor: escuro ? "rgba(245,158,11,0.12)" : "#fffbeb",
      borderBottom: `1px solid ${escuro ? "rgba(245,158,11,0.25)" : "#fde68a"}`,
      fontSize: "0.76rem", color: escuro ? "#fcd34d" : "#92400e", lineHeight: 1.35,
    },

    lista: {
      padding: "6px 0 10px", maxHeight: 440, overflowY: "auto", scrollbarWidth: "thin",
      "&::-webkit-scrollbar": { width: 5 },
      "&::-webkit-scrollbar-thumb": { backgroundColor: escuro ? "rgba(255,255,255,0.2)" : "rgba(0,0,0,0.15)", borderRadius: 10 },
    },
    grupo: {
      padding: "10px 20px 2px", fontSize: "0.66rem", fontWeight: 800, letterSpacing: ".08em",
      textTransform: "uppercase", color: theme.palette.text.secondary,
    },
    item: {
      position: "relative", display: "flex", alignItems: "flex-start", gap: 12,
      margin: "6px 10px", padding: "11px 12px", borderRadius: 14, cursor: "pointer",
      width: "auto", boxSizing: "border-box",
      backgroundColor: escuro ? "rgba(255,255,255,0.03)" : "#ffffff",
      border: `1px solid ${escuro ? "rgba(255,255,255,0.06)" : "rgba(15,23,42,0.06)"}`,
      boxShadow: escuro ? "none" : "0 4px 12px rgba(15,23,42,0.04)",
      transition: "border-color .15s ease, box-shadow .15s ease, transform .15s ease",
      "&:hover": {
        backgroundColor: escuro ? "rgba(255,255,255,0.05)" : "#ffffff",
        borderColor: "rgba(13,148,136,0.35)",
        boxShadow: "0 8px 18px -10px rgba(13,148,136,0.6)",
        transform: "translateY(-1px)",
      },
      "&:hover $itemAcoes": { opacity: 1 },
    },
    itemNaoLido: {
      backgroundColor: escuro ? "rgba(13,148,136,0.10)" : "#effcfa",
      borderColor: escuro ? "rgba(45,212,191,0.22)" : "rgba(13,148,136,0.22)",
    },
    itemBarra: { position: "absolute", left: 0, top: 10, bottom: 10, width: 3, borderRadius: 3 },
    itemIcone: {
      width: 38, height: 38, borderRadius: 12, flexShrink: 0,
      display: "flex", alignItems: "center", justifyContent: "center",
    },
    itemCorpo: { flex: 1, minWidth: 0 },
    itemTopo: { display: "flex", alignItems: "center", gap: 8 },
    itemTitulo: {
      flex: 1, minWidth: 0, fontWeight: 700, fontSize: "0.86rem", color: theme.palette.text.primary,
      whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
    },
    itemHora: { fontSize: "0.7rem", color: theme.palette.text.secondary, flexShrink: 0 },
    itemTexto: {
      fontSize: "0.79rem", color: theme.palette.text.secondary, lineHeight: 1.4, marginTop: 2,
      display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden",
      wordBreak: "break-word",
    },
    itemRodape: { display: "flex", alignItems: "center", gap: 8, marginTop: 6 },
    itemTag: { fontSize: "0.66rem", fontWeight: 800, padding: "2px 8px", borderRadius: 20 },
    itemAcoes: { marginLeft: "auto", display: "flex", gap: 2, opacity: 0, transition: "opacity .15s" },
    itemAcao: { padding: 4, color: theme.palette.text.secondary, "&:hover": { color: "#0D9488" } },
    pontoNaoLido: { width: 8, height: 8, borderRadius: "50%", flexShrink: 0, marginTop: 6 },

    vazio: { padding: "40px 20px", display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", color: theme.palette.text.secondary },
    vazioIcone: { fontSize: 46, color: "#14b8a6", opacity: 0.8, marginBottom: 10, animation: "iaFlutuar 3s ease-in-out infinite" },

    corpoDetalhe: { whiteSpace: "pre-wrap", wordBreak: "break-word", fontSize: "0.9rem", lineHeight: 1.5 },

    // ---------- avisos flutuantes (canto da tela)
    pilhaToasts: {
      position: "fixed", bottom: 24, right: 24, zIndex: 1400,
      display: "flex", flexDirection: "column-reverse", gap: 10, width: 370, maxWidth: "calc(100vw - 32px)",
      pointerEvents: "none",
    },
    toast: {
      position: "relative", overflow: "hidden", pointerEvents: "auto",
      display: "flex", alignItems: "flex-start", gap: 12, padding: "14px 14px 16px 16px",
      borderRadius: 16, backgroundColor: escuro ? "#162221" : "#ffffff",
      border: `1px solid ${escuro ? "rgba(255,255,255,0.08)" : "#dcebe9"}`,
      boxShadow: escuro ? "0 18px 44px rgba(0,0,0,0.55)" : "0 18px 44px rgba(10,38,36,0.18)",
      animation: "iaToastEntrar 0.55s cubic-bezier(0.22, 1, 0.36, 1) backwards",
    },
    toastFaixa: { position: "absolute", left: 0, top: 0, bottom: 0, width: 5 },
    toastIcone: {
      width: 40, height: 40, borderRadius: 12, flexShrink: 0,
      display: "flex", alignItems: "center", justifyContent: "center",
      animation: "iaIconePop .6s .15s cubic-bezier(0.34,1.56,0.64,1) both",
    },
    toastTipo: { fontSize: "0.66rem", fontWeight: 800, letterSpacing: ".06em", textTransform: "uppercase" },
    toastTitulo: { fontWeight: 800, fontSize: "0.9rem", lineHeight: 1.3, color: theme.palette.text.primary, marginTop: 1 },
    toastCorpo: {
      fontSize: "0.8rem", lineHeight: 1.4, color: theme.palette.text.secondary, marginTop: 2,
      display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical", overflow: "hidden", wordBreak: "break-word",
    },
    toastBotoes: { display: "flex", gap: 8, marginTop: 10 },
    toastAbrir: {
      border: "none", cursor: "pointer", fontFamily: "inherit", fontSize: "0.76rem", fontWeight: 800,
      padding: "6px 12px", borderRadius: 8, color: "#fff", display: "inline-flex", alignItems: "center", gap: 6,
      "&:focus": { outline: "none" },
    },
    toastFechar: {
      position: "absolute", top: 6, right: 6, padding: 4, color: theme.palette.text.secondary,
    },
    toastTempo: {
      position: "absolute", left: 0, bottom: 0, height: 3,
      animation: "$encolher linear forwards",
    },
    "@keyframes encolher": { from: { width: "100%" }, to: { width: "0%" } },
  };
});

const LOCAL_STORAGE_KEY = "whaticket_custom_notifications";

const SILENCIO_CLIENTE_MS = 10 * 60 * 1000;

const DURACAO_TOAST_MS = 7000;
// Comunicado e transferencia ficam mais tempo na tela: sao para ler com calma.
const DURACAO_TOAST_LONGA_MS = 15000;



// Fica fora do componente: vale para a pagina inteira, mesmo se o sininho
// for montado de novo.
const AVISOS_RECENTES = new Map();

const NotificationsPopOver = () => {
  const classes = useStyles();
  const history = useHistory();
  const { user } = useContext(AuthContext);
  const ticketIdUrl = +history.location.pathname.split("/")[2];
  const ticketIdRef = useRef(ticketIdUrl);
  const anchorEl = useRef();
  const [isOpen, setIsOpen] = useState(false);

  const [notificationsList, setNotificationsList] = useState(() => {
    try {
      const saved = localStorage.getItem(LOCAL_STORAGE_KEY);
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });

  const [recusaModal, setRecusaModal] = useState(null);

  
  const [detalhe, setDetalhe] = useState(null);

  const [toasts, setToasts] = useState([]);
  const [filtro, setFiltro] = useState("todas");
  const [permissao, setPermissao] = useState(() =>
    suportaNotificacao() ? Notification.permission : "unsupported"
  );

  const ultimoAvisoPorTicket = useRef(new Map());
  
  
  const historyRef = useRef(history);

  useEffect(() => {
    historyRef.current = history;
  }, [history]);

  useEffect(() => {
    ticketIdRef.current = ticketIdUrl;
  }, [ticketIdUrl]);

  // Pede a permissao de notificacao do SO uma vez. Se o navegador so aceitar
  // com um gesto do usuario, um unico clique em qualquer lugar da pagina
  // resolve — por isso o ouvinte com { once: true }.
  useEffect(() => {
    pedirPermissaoNotificacao();
    const aoPrimeiroClique = () => pedirPermissaoNotificacao();
    window.addEventListener("click", aoPrimeiroClique, { once: true });
    return () => window.removeEventListener("click", aoPrimeiroClique);
  }, []);

  useEffect(() => {
    try {
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(notificationsList));
    } catch (e) {
      console.error("Erro ao salvar notificações no localStorage", e);
    }
  }, [notificationsList]);

  const unreadCount = notificationsList.filter((n) => !n.read).length;

  
  const precisaHumano = notificationsList.some(
    (n) => !n.read && n.type === "humano"
  );

  // Aba do CRM fora da vista: outra aba, outra janela por cima ou minimizado.
  // Nesses casos o toast interno ninguem ve — vai o aviso do Windows/macOS e o
  // titulo da aba pisca com a contagem.
  const foraDaVista = () => {
    try {
      return document.visibilityState !== "visible" || !document.hasFocus();
    } catch (e) {
      return false;
    }
  };

  const tituloOriginal = useRef(document.title);
  const naoVistos = useRef(0);
  useEffect(() => {
    const voltar = () => {
      if (document.visibilityState === "visible" && document.hasFocus()) {
        naoVistos.current = 0;
        document.title = tituloOriginal.current;
      }
    };
    document.addEventListener("visibilitychange", voltar);
    window.addEventListener("focus", voltar);
    return () => {
      document.removeEventListener("visibilitychange", voltar);
      window.removeEventListener("focus", voltar);
    };
  }, []);

  // Sons escolhidos em Configuracoes > Sons e notificacoes. Carrega ao abrir e
  // acompanha na hora quando o admin troca.
  useEffect(() => {
    carregarConfigSons();
    const socket = openSocket();
    const aoMudarConfig = (data) => {
      if (data?.action === "update" && data.setting?.key === "sonsNotificacao") {
        aplicarConfigSons(data.setting.value);
      }
    };
    socket.on("settings", aoMudarConfig);

    // Garantia extra (sem precisar de F5): se o aviso do socket se perder
    // (aba em segundo plano, internet oscilou, reconexao), busca de novo ao
    // reconectar, ao voltar para a aba e a cada 1 minuto.
    const recarregar = () => carregarConfigSons();
    const aoVoltarParaAba = () => {
      if (document.visibilityState === "visible") recarregar();
    };
    socket.on("connect", recarregar);
    window.addEventListener("focus", recarregar);
    document.addEventListener("visibilitychange", aoVoltarParaAba);
    const intervalo = setInterval(recarregar, 60 * 1000);

    return () => {
      socket.off("settings", aoMudarConfig);
      socket.off("connect", recarregar);
      window.removeEventListener("focus", recarregar);
      document.removeEventListener("visibilitychange", aoVoltarParaAba);
      clearInterval(intervalo);
    };
  }, []);

  // Alarme de transferencia: toca agora e repete a cada 20s ate o usuario
  // abrir o atendimento (ou 3 minutos, para nao tocar para sempre).
  const alarmes = useRef(new Map());
  const pararAlarme = useCallback((ticketId) => {
    const chave = String(ticketId);
    const a = alarmes.current.get(chave);
    if (a) {
      clearInterval(a.intervalo);
      alarmes.current.delete(chave);
    }
  }, []);
  const iniciarAlarme = useCallback((ticketId) => {
    const chave = String(ticketId);
    const naTela = () => String(window.location.pathname.split("/")[2] || "");
    if (naTela() === chave) return; // ja esta nele
    pararAlarme(chave);
    playAlarmeTransferencia();
    const inicio = Date.now();
    const intervalo = setInterval(() => {
      if (naTela() === chave || Date.now() - inicio > 3 * 60 * 1000) {
        pararAlarme(chave);
        return;
      }
      playAlarmeTransferencia();
    }, 20000);
    alarmes.current.set(chave, { intervalo });
  }, [pararAlarme]);
  useEffect(() => {
    if (ticketIdUrl) pararAlarme(ticketIdUrl);
  }, [ticketIdUrl, pararAlarme]);
  useEffect(() => {
    const destravar = () => destravarAudio();
    document.addEventListener("click", destravar);
    document.addEventListener("keydown", destravar);
    const mapa = alarmes.current;
    return () => {
      document.removeEventListener("click", destravar);
      document.removeEventListener("keydown", destravar);
      mapa.forEach((a) => clearInterval(a.intervalo));
    };
  }, []);

  // som: evento de Configuracoes > Sons e notificacoes (false = sem som)
  // Mesmo aviso (tipo + atendimento + titulo + texto) chegando de novo em
  // menos de 15s e ignorado: nada de lista duplicada, toast repetido ou som.
  const addNotification = useCallback((item, som = "avisoIA") => {
      const assinatura = [item.type, item.ticketId, item.title, item.body].join("|");
      const agora = Date.now();
      const recentes = AVISOS_RECENTES;
      if (agora - (recentes.get(assinatura) || 0) < 15000) return;
      recentes.set(assinatura, agora);
      if (recentes.size > 200) {
        recentes.forEach((t, k) => {
          if (agora - t > 60000) recentes.delete(k);
        });
      }

      setNotificationsList((prev) => {
        
        const filtered = prev.filter((p) => !(p.id === item.id));
        return [
          {
            id: item.id || `notif_${Date.now()}_${Math.random().toString(36).substr(2, 4)}`,
            type: item.type || "message", 
            title: item.title,
            body: item.body,
            ticketId: item.ticketId,
            timestamp: item.timestamp || new Date().toISOString(),
            read: false,
            avatarUrl: item.avatarUrl,
          },
          ...filtered,
        ].slice(0, 50); 
      });

      const idToast =
        item.id || `toast_${Date.now()}_${Math.random().toString(36).slice(2, 6)}`;

      setToasts((prev) => [
        {
          id: idToast,
          type: item.type || "message",
          title: item.title,
          body: item.body,
          ticketId: item.ticketId,
          duracao: ["comunicado", "transfer", "humano"].includes(item.type)
            ? DURACAO_TOAST_LONGA_MS
            : DURACAO_TOAST_MS,
        },
        
        ...prev,
      ].slice(0, 3));

      const duracao = ["comunicado", "transfer", "humano"].includes(item.type)
        ? DURACAO_TOAST_LONGA_MS
        : DURACAO_TOAST_MS;
      window.setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== idToast));
      }, duracao);

      if (som) tocarSom(som);

      // Fora da vista: aviso do sistema operacional + contador no titulo.
      if (item.desktop !== false && foraDaVista()) {
        naoVistos.current += 1;
        document.title = `(${naoVistos.current}) Nova mensagem — ${tituloOriginal.current}`;
        mostrarNotificacaoDesktop({
          titulo: item.title || "Novo aviso",
          corpo: String(item.body || "").slice(0, 140),
          // Um aviso por atendimento: o novo substitui o anterior do mesmo cliente.
          tag: item.ticketId ? `ticket_${item.ticketId}` : item.id,
          aoClicar: () => {
            if (item.ticketId) historyRef.current.push(`/atendimentos/${item.ticketId}`);
          },
        });
      }
      },
    []
  );

  useEffect(() => {
    const socket = openSocket();
    const onConnect = () => socket.emit("joinNotification");
    socket.on("connect", onConnect);
    if (socket.connected) {
      onConnect();
    }

    const onAppmessage = (data) => {
      // So avisa do que e de quem esta logado: atendimento atribuido a ele,
      // ou sem dono e precisando de gente (pediu humano / contato interno).
      // Conversa de outro atendente ou que a I.A esta conduzindo nao avisa.
      const semDono = !data.ticket?.userId;
      const precisaDeGente =
        semDono &&
        poderDeAdmin(user?.profile) &&
        (Boolean(data.ticket?.awaitingHuman) || Boolean(data.ticket?.contact?.interno));
      const ehParaMim = ticketEhMeu(data.ticket, user) || precisaDeGente;

      // Grupo nao gera notificacao (nem som).
      // (o contato da mensagem e quem escreveu; o do ticket e o grupo)
      const ehGrupo = Boolean(
        data.ticket?.isGroup || data.ticket?.contact?.isGroup || data.contact?.isGroup
      );

      if (data.action === "create" && !data.message.read && ehParaMim && !ehGrupo) {
        if (!data.message.fromMe) {
          const criado = new Date(data.ticket?.createdAt || 0).getTime();
          const clienteNovo = criado && Date.now() - criado < 60 * 1000;
          if (clienteNovo) {
            tocarSom("novoCliente");
          } else if (data.ticket.userId === user?.id) {
            tocarSom("mensagem");
          } else {
            // admin acompanhando conversa da I.A ou de outro atendente
            tocarSom("monitor");
          }
        }

        const isCurrentOpenTicket =
          data.message.ticketId === ticketIdRef.current &&
          document.visibilityState === "visible";

        const agora = Date.now();
        const ultimo = ultimoAvisoPorTicket.current.get(data.ticket.id) || 0;
        const dentroDaConversa = agora - ultimo < SILENCIO_CLIENTE_MS;

        if (!isCurrentOpenTicket && !dentroDaConversa) {
          ultimoAvisoPorTicket.current.set(data.ticket.id, agora);

          addNotification({
            id: "msg_" + (data.message.id || data.ticket.id),
            type: "message",
            title: data.contact?.name || "Cliente WhatsApp",
            body: data.message.body || "Nova mensagem recebida",
            ticketId: data.ticket.id,
            timestamp: new Date().toISOString(),
            avatarUrl: data.contact?.profilePicUrl,
            // Aviso do Windows so para cliente DESTE usuario (o admin ve todas
            // as conversas no sininho, mas nao recebe pop-up de todas).
            desktop: !data.message.fromMe && ticketEhMeu(data.ticket, user),
          }, false);
        }
      }
    };
    socket.on("appMessage", onAppmessage);

    const onAinotification = (data) => {
      // Esse aviso vai para todo mundo. Vendedor/operador so precisa saber do
      // cliente que caiu com ELE — e isso ja chega pelo "ticketTransfer".
      if (!poderDeAdmin(user?.profile)) return;

      const precisaHumano = data.type === "ai_transfer";

      addNotification({
        id: `ai_${data.ticketId}_${Date.now()}`,
        type: precisaHumano ? "humano" : "ai",
        title: precisaHumano
          ? `🙋 Precisa de humano: ${data.contactName || "Cliente"}`
          : `🤖 IA: ${data.contactName || "Cliente"}`,
        body: data.message || `A IA transferiu o atendimento: ${data.reason || ""}`,
        ticketId: data.ticketId,
        timestamp: data.timestamp || new Date().toISOString(),
      }, precisaHumano ? "precisaHumano" : "avisoIA");
    };
    socket.on("aiNotification", onAinotification);

    // Conexao de WhatsApp com problema (caiu, foi desconectada, parou de
    // responder). Antes nada avisava: a tela seguia "Conectado" e as mensagens
    // simplesmente paravam de chegar. So administradores e operadores recebem.
    const onConexaoAlerta = (data) => {
      if (!poderDeAdmin(user?.profile)) return;
      addNotification({
        id: `conexao_${data.whatsappId}_${Date.now()}`,
        type: "conexao",
        title: `⚠️ Conexão ${data.conexao || ""}`,
        body: data.mensagem,
        ticketId: null,
        timestamp: data.timestamp || new Date().toISOString(),
      }, "conexaoCaiu");
      toast.error(data.mensagem, { autoClose: 15000 });
    };
    socket.on("conexaoAlerta", onConexaoAlerta);

    // O inverso: a conexao que tinha caido (e ja tinha sido avisada) voltou.
    const onConexaoVoltou = (data) => {
      if (!poderDeAdmin(user?.profile)) return;
      addNotification({
        id: `conexao_ok_${data.whatsappId}_${Date.now()}`,
        type: "conexaoOk",
        title: `✅ Conexão ${data.conexao || ""} voltou`,
        body: data.mensagem,
        ticketId: null,
        timestamp: data.timestamp || new Date().toISOString(),
      }, "conexaoVoltou");
      toast.success(data.mensagem, { autoClose: 10000 });
    };
    socket.on("conexaoVoltou", onConexaoVoltou);

    const onTicketrefused = (data) => {
      addNotification({
        id: `refuse_${data.ticketId}_${Date.now()}`,
        type: "problem",
        title: `⚠️ Atendimento Recusado`,
        body: `${data.userName || "Atendente"} recusou ${data.contactName || "cliente"}. Motivo: ${data.reason || "Não informado"}`,
        ticketId: data.ticketId,
        timestamp: new Date().toISOString(),
      }, "problema");

      if (poderDeAdmin(user?.profile)) {
        setRecusaModal(data);
      }
    };
    socket.on("ticketRefused", onTicketrefused);

    const onSalenotification = (data) => {
      addNotification({
        id: `sale_${Date.now()}`,
        type: "sale",
        title: `🎉 Venda Registrada!`,
        body: data.message || "Nova venda realizada com sucesso!",
        ticketId: data.ticketId,
        timestamp: new Date().toISOString(),
      }, "venda");
    };
    socket.on("saleNotification", onSalenotification);

    // Antes este ouvinte era uma funcao anonima que NUNCA era removida: cada
    // vez que este efeito rodava de novo (troca do usuario, token renovado),
    // empilhava mais um, e a mesma entrevista avisava 2, 3 vezes.
    const onProposal = (data) => {
      addNotification({
        id: `proposal_${data.ticketId}_${data.message || ""}`,
        type: "sale",
        title: data.title || "📅 Entrevista agendada!",
        body: data.message || "A assistente agendou uma entrevista.",
        ticketId: data.ticketId,
        timestamp: data.timestamp || new Date().toISOString(),
      }, "venda");
    };
    socket.on("proposalNotification", onProposal);

    const onTicket = (data) => {
      if (data.action === "updateUnread" || data.action === "delete") {
        setNotificationsList((prev) =>
          prev.map((item) =>
            item.ticketId === data.ticketId ? { ...item, read: true } : item
          )
        );
      }
    };
    socket.on("ticket", onTicket);

    const onTicketTransfer = (data) => {
      // Cliente caiu com ESTE usuario: alarme alto que repete ate ele abrir o
      // atendimento, aviso do sistema que fica na tela ate clicar, e toast.
      addNotification({
        id: `transfer_${data.ticketId}_${Date.now()}`,
        type: "transfer",
        title: data.contactName || "Cliente",
        body: "Foi transferido para você. Toque para abrir o atendimento.",
        ticketId: data.ticketId,
        timestamp: data.timestamp || new Date().toISOString(),
        desktop: false,
      }, false);
      mostrarNotificacaoDesktop({
        titulo: `🔔 Cliente transferido para você: ${data.contactName || "Cliente"}`,
        corpo: "Clique para abrir o atendimento.",
        tag: `transfer_${data.ticketId}`,
        fixo: true,
        aoClicar: () => {
          pararAlarme(data.ticketId);
          historyRef.current.push(`/atendimentos/${data.ticketId}`);
        },
      });
      iniciarAlarme(data.ticketId);
    };
    socket.on("ticketTransfer", onTicketTransfer);

    // Comunicado da equipe (admin/supervisor) num cliente deste usuario.
    const onComunicado = (data) => {
      tocarSom("comunicado");
      addNotification({
        id: `comunicado_${data.ticketId}_${Date.now()}`,
        type: "comunicado",
        title: `${data.autor || "Equipe"} · ${data.contactName || "Cliente"}`,
        body: data.texto || "Novo comunicado no atendimento.",
        ticketId: data.ticketId,
        timestamp: data.timestamp || new Date().toISOString(),
      }, false);
    };
    socket.on("comunicadoNotification", onComunicado);

    return () => {
      socket.off("connect", onConnect);
      socket.off("appMessage", onAppmessage);
      socket.off("aiNotification", onAinotification);
      socket.off("conexaoAlerta", onConexaoAlerta);
      socket.off("conexaoVoltou", onConexaoVoltou);
      socket.off("ticketRefused", onTicketrefused);
      socket.off("saleNotification", onSalenotification);
      socket.off("proposalNotification", onProposal);
      socket.off("ticket", onTicket);
      socket.off("ticketTransfer", onTicketTransfer);
      socket.off("comunicadoNotification", onComunicado);
    };
  }, [user, addNotification, iniciarAlarme, pararAlarme]);

  const handleClearAll = () => {
    setNotificationsList([]);
    try {
      localStorage.removeItem(LOCAL_STORAGE_KEY);
    } catch (e) {
      console.error(e);
    }
  };

  const handleMarkAllAsRead = () => {
    setNotificationsList((prev) => prev.map(n => ({...n, read: true})));
  };

  useEffect(() => {
    if (ticketIdUrl && notificationsList.length > 0) {
      const temNaoLida = notificationsList.some(n => !n.read && String(n.ticketId) === String(ticketIdUrl));
      if (temNaoLida) {
        setNotificationsList(prev => prev.map(n => String(n.ticketId) === String(ticketIdUrl) ? { ...n, read: true } : n));
      }
    }
  }, [ticketIdUrl, notificationsList]);

  const abrirAtendimento = useCallback(
    async (ticketId, notificacaoId) => {
      if (!ticketId) return;
      pararAlarme(ticketId);

      try {
        await api.get(`/tickets/${ticketId}`);
        history.push(`/atendimentos/${ticketId}`);
      } catch (err) {
        
        setNotificationsList((prev) => prev.filter((n) => n.id !== notificacaoId));
        setToasts((prev) => prev.filter((t) => t.id !== notificacaoId));
        toast.info("Esse atendimento não existe mais. Tirei o aviso da lista.");
      }
    },
    [history, pararAlarme]
  );


  const abrirDetalhe = (item) => {
    setNotificationsList((prev) =>
      prev.map((n) => (n.id === item.id ? { ...n, read: true } : n))
    );
    setDetalhe(item);
  };

  const handleNotificationClick = (item) => {
    
    setNotificationsList((prev) =>
      prev.map((n) => (n.id === item.id ? { ...n, read: true } : n))
    );
    setIsOpen(false);

    abrirAtendimento(item.ticketId, item.id);
  };

  const formatNotificationTime = (isoString) => {
    try {
      const date = new Date(isoString);
      return formatDistanceToNow(date, { addSuffix: true, locale: ptBR });
    } catch {
      return "";
    }
  };

  // Filtros, contagem e grupos (Hoje / Anteriores)
  const passaFiltro = (n, f) =>
    f === "todas" ? true
      : f === "naoLidas" ? !n.read
      : f === "transfer" ? ["transfer", "humano"].includes(n.type)
      : f === "conexao" ? ["conexao", "conexaoOk"].includes(n.type)
      : n.type === f;
  const contarFiltro = (f) =>
    f === "todas" ? 0 : notificationsList.filter((n) => !n.read && passaFiltro(n, f)).length;
  const listaFiltrada = notificationsList.filter((n) => passaFiltro(n, filtro));
  const inicioDeHoje = new Date();
  inicioDeHoje.setHours(0, 0, 0, 0);
  const gruposDaLista = [
    { titulo: "Hoje", itens: listaFiltrada.filter((n) => new Date(n.timestamp) >= inicioDeHoje) },
    { titulo: "Anteriores", itens: listaFiltrada.filter((n) => new Date(n.timestamp) < inicioDeHoje) },
  ].filter((g) => g.itens.length);

  // Cor do sino: a do aviso nao lido mais importante.
  const PRIORIDADE = ["problem", "humano", "comunicado", "transfer", "message", "ai", "sale"];
  const tipoMaisUrgente = PRIORIDADE.find((tp) => notificationsList.some((n) => !n.read && n.type === tp));
  const corDoSino = tipoMaisUrgente ? tipoDe(tipoMaisUrgente).cor : "#0d9488";

  return (
    <>
      {}
      <ModalAstro
        open={!!recusaModal}
        onClose={() => setRecusaModal(null)}
        icone={<ReportProblemOutlined />}
        titulo="Atendimento recusado"
        subtitulo="O cliente voltou para a fila de espera."
        acoes={<>
          <Button onClick={() => setRecusaModal(null)} style={{ textTransform: "none" }}>
            Fechar
          </Button>
          <Button
            color="primary"
            variant="contained"
            style={{ textTransform: "none", borderRadius: 8, backgroundColor: "#0D9488" }}
            onClick={() => {
              const id = recusaModal?.ticketId;
              setRecusaModal(null);
              if (id) history.push(`/atendimentos/${id}`);
            }}
          >
            Abrir atendimento
          </Button>
        </>}
      >
          <Typography variant="body1" style={{ marginBottom: 12 }}>
            <strong>{recusaModal?.userName}</strong> recusou o atendimento de{" "}
            <strong>{recusaModal?.contactName}</strong>.
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Motivo informado:
          </Typography>
          <Typography variant="body1" style={{ whiteSpace: "pre-wrap", marginTop: 4, fontWeight: 500 }}>
            {recusaModal?.reason}
          </Typography>
          <Typography variant="caption" color="textSecondary" style={{ display: "block", marginTop: 16 }}>
            O cliente voltou para a fila de espera e pode ser assumido por outro atendente.
          </Typography>
              </ModalAstro>

      {/* ===== Sino ===== */}
      <Tooltip title="Notificações" arrow>
        <IconButton
          onClick={() => setIsOpen((prev) => !prev)}
          ref={anchorEl}
          aria-label="Notificações"
          className={`${classes.iconButton} ${unreadCount > 0 ? classes.sinoTocando : ""}`}
          style={{ position: "relative" }}
        >
          <span style={{ display: "inline-flex", color: unreadCount ? corDoSino : undefined }}>
            {unreadCount ? <NotificationsActiveOutlined fontSize="small" /> : <NotificationsNoneOutlined fontSize="small" />}
          </span>
          {unreadCount > 0 && (
            <span className={classes.contador} style={{ backgroundColor: corDoSino }}>
              {unreadCount > 99 ? "99+" : unreadCount}
            </span>
          )}
        </IconButton>
      </Tooltip>

      {/* ===== Quadro ===== */}
      <Popover
        disableScrollLock
        open={isOpen}
        anchorEl={anchorEl.current}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        classes={{ paper: classes.popoverPaper }}
        onClose={() => setIsOpen(false)}
      >
        <div className={classes.topo}>
          <div className={classes.topoLinha}>
            <div>
              <div className={classes.topoTitulo}>
                <span className={classes.topoSino}><NotificationsOutlined /></span> Notificações
              </div>
              <div className={classes.topoSub}>
                {unreadCount
                  ? `${unreadCount} ${unreadCount === 1 ? "aviso novo" : "avisos novos"} esperando você`
                  : "Tudo em dia por aqui"}
              </div>
            </div>
            {notificationsList.length > 0 && (
              <div className={classes.topoAcoes}>
                <Tooltip title="Marcar todas como lidas" arrow>
                  <IconButton size="small" className={classes.topoBtn} onClick={handleMarkAllAsRead}>
                    <DoneAll style={{ fontSize: 18 }} />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Limpar tudo" arrow>
                  <IconButton size="small" className={classes.topoBtn} onClick={handleClearAll}>
                    <DeleteSweepOutlined style={{ fontSize: 18 }} />
                  </IconButton>
                </Tooltip>
              </div>
            )}
          </div>
          <div className={classes.filtros}>
            {FILTROS.map((f) => {
              const n = contarFiltro(f.id);
              return (
                <button
                  key={f.id}
                  type="button"
                  className={`${classes.filtro} ${filtro === f.id ? classes.filtroAtivo : ""}`}
                  onClick={() => setFiltro(f.id)}
                >
                  {f.rotulo}
                  {n > 0 && <span className={classes.filtroNum}>{n}</span>}
                </button>
              );
            })}
          </div>
        </div>

        {permissao !== "granted" && permissao !== "unsupported" && (
          <div className={classes.avisoPermissao}>
            <NotificationsActiveOutlined style={{ fontSize: 20, flexShrink: 0 }} />
            <span style={{ flex: 1 }}>
              {permissao === "denied"
                ? "Os avisos do Windows estão bloqueados. Clique no cadeado ao lado do endereço do site → Notificações → Permitir."
                : "Ative os avisos do Windows para ser avisado mesmo em outra aba."}
            </span>
            {permissao !== "denied" && (
              <Button
                size="small"
                variant="contained"
                style={{ backgroundColor: "#f59e0b", color: "#fff", textTransform: "none", fontWeight: 700, borderRadius: 8, boxShadow: "none" }}
                onClick={async () => setPermissao(await pedirPermissaoNotificacao())}
              >
                Ativar
              </Button>
            )}
          </div>
        )}

        <List className={classes.lista}>
          {listaFiltrada.length === 0 ? (
            <div className={classes.vazio}>
              <NotificationsNoneOutlined className={classes.vazioIcone} />
              <Typography style={{ fontWeight: 700, fontSize: "0.9rem" }}>
                {filtro === "todas" ? "Nenhuma notificação" : "Nada aqui"}
              </Typography>
              <Typography style={{ fontSize: "0.78rem", marginTop: 4 }}>
                Quando chegar mensagem, transferência ou comunicado, aparece aqui.
              </Typography>
            </div>
          ) : (
            gruposDaLista.map((g) => (
              <React.Fragment key={g.titulo}>
                <div className={classes.grupo}>{g.titulo}</div>
                {g.itens.map((item) => {
                  const tipo = tipoDe(item.type);
                  const { Icone } = tipo;
                  return (
                    <ListItem
                      key={item.id}
                      disableGutters
                      className={`${classes.item} ${!item.read ? classes.itemNaoLido : ""}`}
                      onClick={() => (item.ticketId ? handleNotificationClick(item) : abrirDetalhe(item))}
                    >
                      {!item.read && <span className={classes.itemBarra} style={{ backgroundColor: tipo.cor }} />}
                      <div className={classes.itemIcone} style={{ backgroundColor: `${tipo.cor}1f`, color: tipo.cor }}>
                        {item.avatarUrl && item.type === "message"
                          ? <Avatar src={item.avatarUrl} style={{ width: 38, height: 38, borderRadius: 12 }} />
                          : <Icone style={{ fontSize: 19 }} />}
                      </div>
                      <div className={classes.itemCorpo}>
                        <div className={classes.itemTopo}>
                          <Typography className={classes.itemTitulo}>{item.title}</Typography>
                          <span className={classes.itemHora}>{formatNotificationTime(item.timestamp)}</span>
                        </div>
                        <Typography className={classes.itemTexto}>{item.body}</Typography>
                        <div className={classes.itemRodape}>
                          <span className={classes.itemTag} style={{ backgroundColor: `${tipo.cor}1a`, color: tipo.cor }}>
                            {tipo.rotulo}
                          </span>
                          <div className={classes.itemAcoes}>
                            {!item.read && (
                              <Tooltip title="Marcar como lida" arrow>
                                <IconButton
                                  size="small"
                                  className={classes.itemAcao}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setNotificationsList((prev) => prev.map((n) => (n.id === item.id ? { ...n, read: true } : n)));
                                  }}
                                >
                                  <CheckCircleOutline style={{ fontSize: 16 }} />
                                </IconButton>
                              </Tooltip>
                            )}
                            <Tooltip title="Remover" arrow>
                              <IconButton
                                size="small"
                                className={classes.itemAcao}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setNotificationsList((prev) => prev.filter((n) => n.id !== item.id));
                                }}
                              >
                                <Close style={{ fontSize: 16 }} />
                              </IconButton>
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                      {!item.read && <span className={classes.pontoNaoLido} style={{ backgroundColor: tipo.cor }} />}
                    </ListItem>
                  );
                })}
              </React.Fragment>
            ))
          )}
        </List>
      </Popover>

      {/* ===== Detalhe (aviso sem atendimento) ===== */}
      <ModalAstro
        open={Boolean(detalhe)}
        onClose={() => setDetalhe(null)}
        icone={<NotificationsOutlined />}
        titulo={detalhe?.title || "Notificação"}
        subtitulo={detalhe ? `${tipoDe(detalhe.type).rotulo} · ${formatNotificationTime(detalhe.timestamp)}` : ""}
        acoes={<>
          <Button onClick={() => setDetalhe(null)}>Fechar</Button>
          {detalhe?.ticketId && (
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                const item = detalhe;
                setDetalhe(null);
                handleNotificationClick(item);
              }}
            >
              Abrir atendimento
            </Button>
          )}
        </>}
      >
        <Typography className={classes.corpoDetalhe}>{detalhe?.body}</Typography>
      </ModalAstro>

      {/* ===== Avisos flutuantes (portal no body: a barra do topo tem
           backdrop-filter, que quebraria o position:fixed aqui dentro) ===== */}
      {toasts.length > 0 && !isOpen && createPortal(
        <div className={classes.pilhaToasts}>
          {toasts.map((t) => {
            const tipo = tipoDe(t.type);
            const { Icone } = tipo;
            return (
              <div key={t.id} className={classes.toast}>
                <span className={classes.toastFaixa} style={{ backgroundColor: tipo.cor }} />
                <div className={classes.toastIcone} style={{ backgroundColor: `${tipo.cor}1f`, color: tipo.cor }}>
                  <Icone style={{ fontSize: 20 }} />
                </div>
                <div style={{ minWidth: 0, flex: 1, paddingRight: 18 }}>
                  <div className={classes.toastTipo} style={{ color: tipo.cor }}>{tipo.rotulo}</div>
                  <div className={classes.toastTitulo}>{t.title}</div>
                  <div className={classes.toastCorpo}>{t.body}</div>
                  {t.ticketId && (
                    <div className={classes.toastBotoes}>
                      <button
                        type="button"
                        className={classes.toastAbrir}
                        style={{ backgroundColor: tipo.cor }}
                        onClick={() => {
                          setToasts((prev) => prev.filter((x) => x.id !== t.id));
                          setNotificationsList((prev) => prev.map((n) => (n.id === t.id ? { ...n, read: true } : n)));
                          abrirAtendimento(t.ticketId, t.id);
                        }}
                      >
                        <OpenInNew style={{ fontSize: 14 }} /> Abrir atendimento
                      </button>
                    </div>
                  )}
                </div>
                <IconButton
                  size="small"
                  className={classes.toastFechar}
                  onClick={() => setToasts((prev) => prev.filter((x) => x.id !== t.id))}
                >
                  <Close style={{ fontSize: 16 }} />
                </IconButton>
                <span
                  className={classes.toastTempo}
                  style={{ backgroundColor: tipo.cor, animationDuration: `${t.duracao || DURACAO_TOAST_MS}ms` }}
                />
              </div>
            );
          })}
        </div>,
        document.body
      )}
    </>
  );
};

export default NotificationsPopOver;








